import { getTranslatedText } from '@nile/components';
import { Tooltip, TooltipProps } from 'react-clone-tippy';
import React, { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

type RTippyProps = {
  text: string;
} & TooltipProps;

export function ReactCloneTippy({
  text,
  ...props
}: PropsWithChildren<RTippyProps>) {
  const intl = useIntl();
  return (
    <Tooltip
      html={getTranslatedText(intl, text)}
      delay={400}
      duration={250}
      position="bottom"
      inertia
      trigger="mouseenter"
      animation="shift"
      animateFill={false}
      distance={45}
      className="cursor-pointer"
      {...props}
    />
  );
}
